import { Content } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';

interface PurchaseTicketFlowTitleProps {
  showSearch: boolean;
  isSingleInputModeForMultiEvent: boolean;
  currentGroupIndex: number;
  currentGroupTicketsCount: number;
  groupsOfTicketGroupCount: number;
}

export const PurchaseTicketFlowTitle = ({
  currentGroupTicketsCount,
  currentGroupIndex,
  isSingleInputModeForMultiEvent,
  showSearch,
  groupsOfTicketGroupCount,
}: PurchaseTicketFlowTitleProps) => {
  if (showSearch) {
    return <Content id={ContentId.WhatTicketsDidYouBuy} />;
  }

  if (!showSearch && !isSingleInputModeForMultiEvent) {
    return (
      <>
        <Content id={ContentId.Event} /> {`${currentGroupIndex + 1}`}
      </>
    );
  }

  if (!showSearch && isSingleInputModeForMultiEvent) {
    const eventStrId =
      groupsOfTicketGroupCount == 1 ? ContentId.Group : ContentId.Groups;

    return (
      <>
        {currentGroupIndex + 1} / {groupsOfTicketGroupCount}{' '}
        <Content id={eventStrId} />
      </>
    );
  }

  return '';
};
